import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepup',
  templateUrl: './stepup.component.html',
  styleUrls: ['./stepup.component.scss']
})
export class StepupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
